import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, NgZone } from '@angular/core';

@Component({
  selector: 'app-digital-clock',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Default,
  template: `
    <div class="flex items-center gap-2 select-none">
      <div class="flex items-center gap-1 rounded-lg bg-white/10 px-4 py-1.5 backdrop-blur-sm">
        <span class="font-mono text-xl font-bold tracking-wider text-white">{{ hours }}</span>
        <span class="font-mono text-xl font-bold text-white/70 animate-pulse">:</span>
        <span class="font-mono text-xl font-bold tracking-wider text-white">{{ minutes }}</span>
        <span class="font-mono text-xl font-bold text-white/70 animate-pulse">:</span>
        <span class="font-mono text-xl font-bold tracking-wider text-white">{{ seconds }}</span>
        <span class="ml-2 text-xs font-semibold uppercase text-white/60">{{ amPm }}</span>
      </div>
      <!--<div class="hidden sm:flex flex-col items-start">
        <span class="text-[11px] font-medium text-white/80">{{ dayName }}</span>
        <span class="text-[10px] text-white/50">{{ dateString }}</span>
      </div>-->
    </div>
  `
})
export class DigitalClock implements OnInit, OnDestroy {
  hours = '00';
  minutes = '00';
  seconds = '00';
  amPm = 'AM';
  dayName = '';
  dateString = '';
  private intervalId: any;

  constructor(private cdr: ChangeDetectorRef, private ngZone: NgZone) {}

  ngOnInit(): void {
    this.updateTime();
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.updateTime();
        this.cdr.detectChanges();
      }, 1000);
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateTime(): void {
    const now = new Date();
    let h = now.getHours();
    this.amPm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    this.hours = h.toString().padStart(2, '0');
    this.minutes = now.getMinutes().toString().padStart(2, '0');
    this.seconds = now.getSeconds().toString().padStart(2, '0');
    this.dayName = now.toLocaleDateString('en-US', { weekday: 'long' });
    this.dateString = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
}
